import axios from "./api";

const IjaraService = {

    async getIjaraList() {
        try {
            const response = await axios.get('/ijara');
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || 'Error updating profile';
        }
    },
    async getIjaraListByFilter(pageNumber, perPage, search, orderBy, days, transportId, last) {
        try {
            const response = await axios.get('/ijara', {
                params: {
                    per_page: perPage,
                    page: pageNumber,
                    search: search,
                    order_by: orderBy,
                    days: days,
                    transport_id: transportId,
                    last: last
                }
            });
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || 'Error updating profile';
        }
    },

    async addIjara(formData) {
        try {
            const response = await axios.post('/ijara', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || 'Error updating profile';
        }
    },
    async updateIjara(formData, id) {
        try {
            const response = await axios.post('/ijara/' + id+ '?_method=PUT', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || 'Error updating ijara';
        }
    },
    async deleteIjara(id) {
        try {
            const response = await axios.delete('/ijara/' + id);
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || 'Error deleting ijara';
        }
    }
}

export default IjaraService;